import React from 'react';

import { Divider as PrismDivider } from '@nutanix-ui/prism-reactjs';
import type { DividerProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Divider/Divider';
import { DividerAppearance } from '@nutanix-ui/prism-reactjs/lib/components/v2/Divider/Divider';

export { DividerProps, DividerAppearance };

export default function Divider(props: React.PropsWithChildren<DividerProps>) {
  return <PrismDivider {...props} />;
}
